import React, { useEffect, useRef, useState } from "react";
import arrowGray from "../../src/asset/images/arrow-down1.svg";

const MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

const WEEK_DAYS = ["M", "T", "W", "T", "F", "S", "S"];

// const MAX_RANGE_DAYS = 31;

const formatDate = (date) => {
    if (!date) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
};

const parseDate = (value) => {
    if (!value) return null;

    const parts = value.split("-");

    if (parts.length !== 3) return null;

    const day = Number(parts[0]);
    const month = Number(parts[1]);
    const year = Number(parts[2]);

    if (!day || !month || !year) return null;

    const date = new Date(year, month - 1, day);

    // Important: catches 31-02-2026 etc.
    if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
    ) {
        return null;
    }

    return date;
};

const startOfDay = (date) => {
    if (!date) return null;

    return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
    );
};

const isSameDate = (date1, date2) => {
    if (!date1 || !date2) return false;

    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    );
};

const isBefore = (date1, date2) => {
    return startOfDay(date1) < startOfDay(date2);
};

const isAfter = (date1, date2) => {
    return startOfDay(date1) > startOfDay(date2);
};

const getCalendarDays = (year, month) => {
    const firstDay = new Date(year, month, 1);

    // Convert Sunday=0 to Monday=0
    let startDay = firstDay.getDay() - 1;

    if (startDay < 0) {
        startDay = 6;
    }

    const daysInMonth = new Date(year, month + 1, 0).getDate();

    const days = [];

    // Previous month days
    const previousMonthDays = new Date(year, month, 0).getDate();

    for (let i = startDay - 1; i >= 0; i--) {
        days.push({
            date: new Date(year, month - 1, previousMonthDays - i),
            currentMonth: false,
        });
    }

    // Current month
    for (let day = 1; day <= daysInMonth; day++) {
        days.push({
            date: new Date(year, month, day),
            currentMonth: true,
        });
    }

    // Next month
    let nextDay = 1;

    while (days.length < 42) {
        days.push({
            date: new Date(year, month + 1, nextDay),
            currentMonth: false,
        });

        nextDay++;
    }

    return days;
};

const DateRangePicker = ({
    dateErr,
    fromDate,
    toDate,
    onFromDateChange,
    onToDateChange,
    maxDate = new Date(),
}) => {
    const [showCalendar, setShowCalendar] = useState(true);
    const [activeField, setActiveField] = useState("from");
    const [calendarDate, setCalendarDate] = useState(
        startOfDay(parseDate(fromDate)) || new Date()
    );
    const [fromInput, setFromInput] = useState(fromDate || "");
    const [toInput, setToInput] = useState(toDate || "");
    const [errors, setErrors] = useState({
    from: "",
    to: "",
});
    const [openDropdown, setOpenDropdown] = useState(null);

    const calendarRef = useRef(null);

    useEffect(() => {
        setFromInput(fromDate || "");
    }, [fromDate]);

    useEffect(() => {
        setToInput(toDate || "");
    }, [toDate]);

    const today = startOfDay(maxDate);

    const handleMonthSelect = (monthIndex) => {
    setCalendarDate(
        new Date(
            calendarDate.getFullYear(),
            monthIndex,
            1
        )
    );

    setOpenDropdown(null);
    };

    const handleYearSelect = (year) => {
    setCalendarDate(
        new Date(
            year,
            calendarDate.getMonth(),
            1
        )
    );

    setOpenDropdown(null);
};

const currentYear = today.getFullYear();

const YEARS = [];

for (let year = currentYear; year >= 1700; year--) {
    YEARS.push(year);
}

    const selectedFrom = parseDate(fromInput);
    const selectedTo = parseDate(toInput);

    const calendarDays = getCalendarDays(
        calendarDate.getFullYear(),
        calendarDate.getMonth()
    );

    const isValidDate = (date) => {
        if (!date) return false;

        return !isAfter(date, today);
    };

    // const handleDateSelect = (date) => {
    //     const selectedDate = startOfDay(date);

    //     if (!isValidDate(selectedDate)) {
    //         setError("Future dates are not allowed.");
    //         return;
    //     }

    //     setError("");

    //     if (activeField === "from") {
    //         if (selectedTo && isAfter(selectedDate, selectedTo)) {
    //             setError("From Date cannot be after To Date.");
    //             return;
    //         }

    //         setFromInput(formatDate(selectedDate));
    //         onFromDateChange(formatDate(selectedDate));

    //         // Once From is selected, move to To
    //         setActiveField("to");

    //         if (selectedTo) {
    //             setCalendarDate(selectedTo);
    //         }

    //         return;
    //     }

    //     if (activeField === "to") {
    //         if (selectedFrom && isBefore(selectedDate, selectedFrom)) {
    //             setError("To Date cannot be before From Date.");
    //             return;
    //         }

    //         // if (
    //         //     selectedFrom &&
    //         //     getDaysDifference(selectedFrom, selectedDate) > MAX_RANGE_DAYS
    //         // ) {
    //         //     setError("Date range cannot be more than 31 days.");
    //         //     return;
    //         // }

    //         setToInput(formatDate(selectedDate));
    //         onToDateChange(formatDate(selectedDate));
    //     }
    // };

    // const handleInputChange = (value, field) => {
    //     // Only numbers
    //     let cleanValue = value.replace(/\D/g, "");

    //     // DDMMYYYY
    //     cleanValue = cleanValue.slice(0, 8);

    //     let formatted = cleanValue;

    //     if (cleanValue.length > 2) {
    //         formatted =
    //             cleanValue.substring(0, 2) +
    //             "-" +
    //             cleanValue.substring(2);
    //     }

    //     if (cleanValue.length > 4) {
    //         formatted =
    //             cleanValue.substring(0, 2) +
    //             "-" +
    //             cleanValue.substring(2, 4) +
    //             "-" +
    //             cleanValue.substring(4);
    //     }

    //     if (field === "from") {
    //         setFromInput(formatted);
    //         onFromDateChange(formatted);
    //     } else {
    //         setToInput(formatted);
    //         onToDateChange(formatted);
    //     }

    //     setError("");

    //     if (cleanValue.length === 8) {
    //         const parsed = parseDate(formatted);

    //         if (!parsed) {
    //             setError("Please enter a valid date.");
    //             return;
    //         }

    //         if (isAfter(parsed, today)) {
    //             setError("Future dates are not allowed.");
    //             return;
    //         }

    //         if (
    //             field === "to" &&
    //             selectedFrom &&
    //             isBefore(parsed, selectedFrom)
    //         ) {
    //             setError("To Date cannot be before From Date.");
    //             return;
    //         }

    //         // if (
    //         //     field === "to" &&
    //         //     selectedFrom &&
    //         //     getDaysDifference(selectedFrom, parsed) > MAX_RANGE_DAYS
    //         // ) {
    //         //     setError("Date range cannot be more than 31 days.");
    //         // }

    //         setCalendarDate(parsed);
    //     }
    // };

    const handleDateSelect = (date) => {
    const selectedDate = startOfDay(date);

    if (!isValidDate(selectedDate)) {
        setErrors((prev) => ({
            ...prev,
            [activeField]: "Future dates are not allowed.",
        }));
        return;
    }

    setErrors({
        from: "",
        to: "",
    });

    if (activeField === "from") {
        if (selectedTo && isAfter(selectedDate, selectedTo)) {
            setErrors((prev) => ({
                ...prev,
                from: "From Date cannot be after To Date.",
            }));
            return;
        }

        const formattedDate = formatDate(selectedDate);

        setFromInput(formattedDate);
        onFromDateChange(formattedDate);

        setActiveField("to");

        if (selectedTo) {
            setCalendarDate(selectedTo);
        }

        return;
    }

    if (activeField === "to") {
        if (selectedFrom && isBefore(selectedDate, selectedFrom)) {
            setErrors((prev) => ({
                ...prev,
                to: "To Date cannot be before From Date.",
            }));
            return;
        }

        const formattedDate = formatDate(selectedDate);

        setToInput(formattedDate);
        onToDateChange(formattedDate);
    }
};
    const handleInputChange = (value, field) => {
    // Only numbers
    let cleanValue = value.replace(/\D/g, "");

    // DDMMYYYY
    cleanValue = cleanValue.slice(0, 8);

    let formatted = cleanValue;

    if (cleanValue.length > 2) {
        formatted =
            cleanValue.substring(0, 2) +
            "-" +
            cleanValue.substring(2);
    }

    if (cleanValue.length > 4) {
        formatted =
            cleanValue.substring(0, 2) +
            "-" +
            cleanValue.substring(2, 4) +
            "-" +
            cleanValue.substring(4);
    }

    // Clear error only for the field being edited
    setErrors((prev) => ({
        ...prev,
        [field]: "",
    }));

    if (field === "from") {
        setFromInput(formatted);
        onFromDateChange(formatted);
    } else {
        setToInput(formatted);
        onToDateChange(formatted);
    }

    // Don't validate until 8 digits are entered
    if (cleanValue.length !== 8) {
        return;
    }

    const parsed = parseDate(formatted);

    // Invalid date: 31-02-2026, 30-02-2026 etc.
    if (!parsed) {
        setErrors((prev) => ({
            ...prev,
            [field]: "Please enter a valid date.",
        }));
        return;
    }

    // Future date
    if (isAfter(parsed, today)) {
        setErrors((prev) => ({
            ...prev,
            [field]: "Future dates are not allowed.",
        }));
        return;
    }

    const currentFrom = field === "from"
        ? parsed
        : parseDate(fromInput);

    const currentTo = field === "to"
        ? parsed
        : parseDate(toInput);

    // From Date cannot be after To Date
    if (field === "from" && currentTo && isAfter(parsed, currentTo)) {
        setErrors((prev) => ({
            ...prev,
            from: "From Date cannot be after To Date.",
        }));
        return;
    }

    // To Date cannot be before From Date
    if (field === "to" && currentFrom && isBefore(parsed, currentFrom)) {
        setErrors((prev) => ({
            ...prev,
            to: "To Date cannot be before From Date.",
        }));
        return;
    }

    setCalendarDate(parsed);
};

    return (
        <div className="date-range-picker" ref={calendarRef}>

            <div className="date-input-row">

                <div className="date-field">
                    <label>
                        From Date
                        <span className="mandatory">*</span>
                    </label>

                    <div
                        className={`date-input-box ${
                            activeField === "from" ? "active" : ""
                        }`}
                        onClick={() => {
                            setActiveField("from");

                            const date = parseDate(fromInput);

                            setCalendarDate(
                                date || selectedTo || new Date()
                            );
                        }}
                    >
                        <input
                            type="text"
                            placeholder="DD-MM-YYYY"
                            value={fromInput}
                            maxLength={10}
                            onChange={(e) =>
                                handleInputChange(e.target.value, "from")
                            }
                            onFocus={() => {
                                setActiveField("from");

                                const date = parseDate(fromInput);

                                if (date) {
                                    setCalendarDate(date);
                                }
                            }}
                        />

                   
                        <span className="calendar-icon" 
                        onClick={(e) => {
                            e.stopPropagation();
                            setActiveField("from");
                            setShowCalendar((prev) => !prev);
                        }}>
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <rect
                                    x="3"
                                    y="4"
                                    width="18"
                                    height="17"
                                    rx="2"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                />
                                <path
                                    d="M8 2V6M16 2V6M3 9H21"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </span>
                    
                    </div>

                    {errors.from && (
                        <div className="date-error">
                            {errors.from}
                        </div>
                    )}
                </div>

                <div className="date-field">
                    <label>
                        To Date
                        <span className="mandatory">*</span>
                    </label>

                    <div
                        className={`date-input-box ${
                            activeField === "to" ? "active" : ""
                        }`}
                        onClick={() => {
                            setActiveField("to");

                            const date = parseDate(toInput);

                            setCalendarDate(
                                date || selectedFrom || new Date()
                            );
                        }}
                    >
                        <input
                            type="text"
                            placeholder="DD-MM-YYYY"
                            value={toInput}
                            maxLength={10}
                            onChange={(e) =>
                                handleInputChange(e.target.value, "to")
                            }
                            onFocus={() => {
                                setActiveField("to");

                                const date = parseDate(toInput);

                                if (date) {
                                    setCalendarDate(date);
                                }
                            }}
                        />

                        <span className="calendar-icon" 
                        onClick={(e) => {
                            e.stopPropagation();
                            setActiveField("to");
                            setShowCalendar((prev) => !prev);
                        }}>
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <rect
                                    x="3"
                                    y="4"
                                    width="18"
                                    height="17"
                                    rx="2"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                />
                                <path
                                    d="M8 2V6M16 2V6M3 9H21"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </span>
                    </div>

                    {errors.to && (
                        <div className="date-error">
                            {errors.to}
                        </div>
                    )}
                </div>

                
            </div>
            { showCalendar &&(
                <div className="calendar-panel">

                    <div className="calendar-header">

        <div className="calendar-dropdown-wrapper">

            <button
                type="button"
                className="calendar-dropdown-trigger"
                onClick={() => {
                    setOpenDropdown(
                        openDropdown === "month"
                            ? null
                            : "month"
                    );
                }}
            >
                <span>
                    {MONTHS[calendarDate.getMonth()]}
                </span>

                <img
                    src={arrowGray}
                    alt=""
                    className={
                        openDropdown === "month"
                            ? "dropdown-arrow open"
                            : "dropdown-arrow"
                    }
                />
            </button>

            {openDropdown === "month" && (
                <div className="calendar-dropdown month-dropdown">

                    {MONTHS.map((month, index) => (
                        <button
                            type="button"
                            key={month}
                            className={
                                index === calendarDate.getMonth()
                                    ? "dropdown-option selected"
                                    : "dropdown-option"
                            }
                            onClick={() =>
                                handleMonthSelect(index)
                            }
                        >
                            {month}
                        </button>
                    ))}

                </div>
            )}

        </div>


        <div className="calendar-dropdown-wrapper">

            <button
                type="button"
                className="calendar-dropdown-trigger"
                onClick={() => {
                    setOpenDropdown(
                        openDropdown === "year"
                            ? null
                            : "year"
                    );
                }}
            >
                <span>
                    {calendarDate.getFullYear()}
                </span>

                <img
                    src={arrowGray}
                    alt=""
                    className={
                        openDropdown === "year"
                            ? "dropdown-arrow open"
                            : "dropdown-arrow"
                    }
                />
            </button>

            {openDropdown === "year" && (
                <div className="calendar-dropdown year-dropdown">

                    {YEARS.map((year) => (
                        <button
                            type="button"
                            key={year}
                            className={
                                year === calendarDate.getFullYear()
                                    ? "dropdown-option selected"
                                    : "dropdown-option"
                            }
                            onClick={() =>
                                handleYearSelect(year)
                            }
                        >
                            {year}
                        </button>
                    ))}

                </div>
            )}

        </div>

    </div>

                    <div className="calendar-week">
                        {WEEK_DAYS.map((day, index) => (
                            <div
                                className="calendar-week-day"
                                key={index}
                            >
                                {day}
                            </div>
                        ))}
                    </div>

                    <div className="calendar-grid">

                        {calendarDays.map(
                            ({ date, currentMonth }, index) => {

                                const disabledDate = isAfter(
                                    date,
                                    today
                                );

                                const selectedFromDate =
                                    selectedFrom &&
                                    isSameDate(date, selectedFrom);

                                const selectedToDate =
                                    selectedTo &&
                                    isSameDate(date, selectedTo);

                                const inRange =
                                    selectedFrom &&
                                    selectedTo &&
                                    isAfter(date, selectedFrom) &&
                                    isBefore(date, selectedTo);

                                return (
                                    <button
                                        type="button"
                                        key={index}
                                        className={`
                                            calendar-day
                                            ${!currentMonth ? "other-month" : ""}
                                            ${disabledDate ? "disabled" : ""}
                                            ${inRange ? "in-range" : ""}
                                            ${
                                                selectedFromDate
                                                    ? "selected-start"
                                                    : ""
                                            }
                                            ${
                                                selectedToDate
                                                    ? "selected-end"
                                                    : ""
                                            }
                                        `}
                                        disabled={disabledDate}
                                        onClick={() =>
                                            handleDateSelect(date)
                                        }
                                    >
                                        {date.getDate()}
                                    </button>
                                );
                            }
                        )}
                    </div>
                
                </div>
            )}
        <div className="main-err">
         {dateErr && (
            <div className="date-error">
                {dateErr}
            </div>
        )}
        </div>
        </div>
        
    );
};

export default DateRangePicker;